// extracted by mini-css-extract-plugin
export var OurClients = "Image-slider-module--OurClients--1e9d2";
export var cMarginTop = "Image-slider-module--c-margin-top--4239e";
export var cPadding = "Image-slider-module--c-padding--e74f7";
export var cPaddingBottom = "Image-slider-module--c-padding-bottom--e2049";
export var cPaddingTop = "Image-slider-module--c-padding-top--bdcc8";
export var desktopGrid = "Image-slider-module--desktopGrid--8a1ce";
export var gridItem = "Image-slider-module--gridItem--88f53";
export var logo = "Image-slider-module--logo--68c79";
export var maxWidth = "Image-slider-module--max-width--abc46";
export var mobileScroll = "Image-slider-module--mobileScroll--318a4";
export var mobileScroller = "Image-slider-module--mobileScroller--221f7";
export var scrollerTrack = "Image-slider-module--scrollerTrack--fcee6";